import { StudySiteEssential } from "@maven-rest/cdms/study/Site.dto";
import { createContext, useContext, useState } from "react";

interface PreScreeningSiteContextProps {
  studySites: Array<StudySiteEssential>;
  selectedSite: StudySiteEssential | null;
  setSelectedSite: (site: StudySiteEssential | null) => void;
}

interface PreScreeningSiteContextProviderProps {
  selectedSite: StudySiteEssential | null;
  studySites: Array<StudySiteEssential>;
  children: React.ReactNode;
}

const PreScreeningSiteContext = createContext<PreScreeningSiteContextProps>({
  selectedSite: null,
  studySites: [],
  setSelectedSite: () => {},
});

export function PreScreeningSiteContextProvider(props: PreScreeningSiteContextProviderProps) {
  const [selectedSite, setSelectedSite] = useState<StudySiteEssential | null>(props.selectedSite);

  return (
    <PreScreeningSiteContext.Provider value={{ studySites: props.studySites, selectedSite, setSelectedSite }}>
      {props.children}
    </PreScreeningSiteContext.Provider>
  );
}

export function usePreScreeningSiteContext() {
  return useContext(PreScreeningSiteContext);
}
